import { styled as muiStyled } from '@mui/material/styles';
import { Stack, TableCell, alpha } from '@mui/material';
import { abyssColors } from '../../../../theme/colors';

export const StyledTableCell = muiStyled(TableCell)(() => ({
  width: '9.5%',
  padding: '0.5rem 16px',
  display: 'flex',
  alignItems: 'center',
  borderBottom: 'none',
}));

export const DisabledOverlay = muiStyled(Stack)(() => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
  background: alpha(abyssColors.primary[50], 0.9),
  zIndex: 10,
  alignItems: 'center',
  justifyContent: 'center',
}));

export const closeIconStyles = {
  fontSize: '1.6rem',
  color: abyssColors.primary[500],
};

export const dialogStyles = {
  '.MuiDialog-container': {
    alignItems: 'baseline',
    paddingTop: '23rem',
  },
};

export const paperStyles = {
  maxWidth: '47.2rem',
  height: '20.3rem',
};

export const titleStyles = {
  padding: '2.4rem',
  paddingBottom: '1rem',
  typography: 'h4',
};

export const actionsStyles = {
  borderTop: `0.1rem solid ${abyssColors.primary[100]}`,
  padding: '1.6rem 2.4rem',
  gap: '1.6rem',
  button: {
    margin: '0 !important',
  },
};

export const contentStyles = {
  padding: '2.4rem',
  paddingBottom: '3.2rem',
};
